import React, { useEffect, useState } from 'react'

import { formatPercentageValue } from 'features/views/attributes/hooks/usePercentageAttributeDisplayState'

import { Input } from 'ui/components/Input'

export const PercentageDefaultValue: React.FC<{
    value: FieldDto['default_value']
    onChange: (value: FieldDto['default_value']) => void
}> = ({ value, onChange }) => {
    const [inputValue, setInputValue] = useState<string>(() => {
        return !isNaN(parseFloat(value?.value)) ? String(value?.value * 100) : ''
    })

    useEffect(() => {
        // Update local input value only when external value changes (e.g. reset or programmatic update)
        const raw = value?.value
        const rawString = !isNaN(parseFloat(raw)) ? String(raw * 100) : ''
        if (rawString !== inputValue) {
            setInputValue(rawString)
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps -- intentionally not including inputValue here
    }, [value?.value])

    const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        const val = e.target.value
        setInputValue(val)

        const parsed = parseFloat(val)
        if (!isNaN(parsed)) {
            const scaledVal = parsed / 100
            onChange({ type: 'constant', value: scaledVal })
        } else {
            onChange({ type: 'constant', value: undefined })
        }
    }

    const handleBlur = () => {
        const parsed = parseFloat(inputValue)
        if (!isNaN(parsed)) {
            const formatted = formatPercentageValue(parsed / 100)
            setInputValue(formatted)
        }
    }

    const handleFocus = () => {
        if (value?.value != null) {
            const raw = String(value.value * 100)
            setInputValue(raw)
        }
    }

    return (
        <Input
            type="text"
            placeholder="Enter default value"
            value={inputValue}
            onChange={handleChange}
            onBlur={handleBlur}
            onFocus={handleFocus}
        />
    )
}
